import { render, staticRenderFns } from "./TendersBidTable.vue?vue&type=template&id=17f9d6a2&scoped=true&"
import script from "./TendersBidTable.vue?vue&type=script&lang=js&"
export * from "./TendersBidTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/dashboard/datatable.scss?vue&type=style&index=0&id=17f9d6a2&scoped=true&lang=css&"
import style1 from "./TendersBidTable.vue?vue&type=style&index=1&id=17f9d6a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f9d6a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17f9d6a2')) {
      api.createRecord('17f9d6a2', component.options)
    } else {
      api.reload('17f9d6a2', component.options)
    }
    module.hot.accept("./TendersBidTable.vue?vue&type=template&id=17f9d6a2&scoped=true&", function () {
      api.rerender('17f9d6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/TendersBidTable.vue"
export default component.exports